import React, { useState } from 'react'
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import { ApprovalStagesTable, LetterTatTable } from './ApprovalStages';
import { ApproveformatTable } from './billingApprovalStages/ApproveFormatTable';
import EmployeeRoleTable from './Employeeroles/EmployeeRoleTable';
import ImprestFormatTable from './ImprestFormats/ImprestFormatTables';
import Division from './Division';
import Client from './Client';
import Sector from './Sector';
import DeductionHeading from './DeductionHeading';
// import Tds from './Tds';
import LetterHeading from "./LetterHeading"

const Settings = () => {

    const [toggleState, setToggleState] = useState(2);
    const subcompanyId = sessionStorage.getItem("sitemanagement_project_sub_company")

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'Approval Stages';
            case 2:
                return "Letter Tat";
            case 3:
                return "Employee Role Table";
            case 4:
                return "Imprest Format";
            case 5:
                return "Approval Formats";
            case 6:
                return "Division";
            case 7:
                return "Sector";
            case 8:
                return "Client";
            case 9:
                return "Deduction Heading Salary";
            case 10:
                return "Tds";
            default:
                return 'Settings';
        }
    };

    return (
        <>
            <div>
                <Dashboardnavbar name={getSelectedTitle()} url="Settings" />
                <div className="bloc-tabss  wfm-margin">
                    {/* <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(1)}
                    >
                        Approval Stages
                    </button> */}

                    <button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(2)}
                    >
                        Letter Tat
                    </button>
                    <button
                        className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(3)}
                    >
                        Employee Role Table
                    </button>
                    {subcompanyId !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" &&
                        <>
                            <button
                                className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                                onClick={() => setToggleState(4)}
                            >
                                Imprest Defaults Formats
                            </button>
                            <button
                                className={toggleState === 5 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                                onClick={() => setToggleState(5)}
                            >
                                Dynamic Approval Formats
                            </button>
                        </>
                    }
                    <button
                        className={toggleState === 6 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(6)}
                    >
                        Division
                    </button>
                    {/* <button
                        className={toggleState === 7 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(7)}
                    >
                        Sector
                    </button> */}
                    {/* <button
                        className={toggleState === 8 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(8)}
                    >
                        Client
                    </button> */}
                    {/* <button
                        className={toggleState === 9 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(9)}
                    >
                        Deduction Heading
                    </button> */}
                    {/* <button
                        className={toggleState === 10 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(10)}
                    >
                        Tds
                    </button> */}
                    <button
                        className={toggleState === 11 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(11)}
                    >
                        Letter Type Heading
                    </button>
                </div>

                <div className="content-tabs">

                    {/* {toggleState === 1 ? <ApprovalStagesTable /> : null} */}
                    {toggleState === 2 ? <LetterTatTable subCompanyId={subcompanyId} /> : null}
                    {toggleState === 3 ? <EmployeeRoleTable subCompanyId={subcompanyId} /> : null}
                    {toggleState === 4 ? <ImprestFormatTable /> : null}
                    {toggleState === 5 ? <ApproveformatTable /> : null}
                    {toggleState === 6 ? <Division subCompanyId={subcompanyId} /> : null}
                    {toggleState === 7 ? <Sector /> : null}
                    {toggleState === 8 ? <Client /> : null}
                    {toggleState === 9 ? <DeductionHeading /> : null}
                    {/* {toggleState === 10 ? <Tds /> : null} */}
                    {toggleState === 11 ? <LetterHeading /> : null}
                </div>
            </div>

        </>
    )
}

export default Settings
